"use strict";

export default {
  accessToken(state) {
    return state.accessToken;
  },
};
